import { render, staticRenderFns } from "./UiElements.vue?vue&type=template&id=855934ea&scoped=true&"
import script from "./UiElements.vue?vue&type=script&lang=js&"
export * from "./UiElements.vue?vue&type=script&lang=js&"
import style0 from "./UiElements.vue?vue&type=style&index=0&id=855934ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855934ea",
  null
  
)

export default component.exports